import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

export const getStreamingPageLogMes = (entityType: string, tab: string) => {
  if (entityType === 'mobile') {
    if (tab === 'hourswatched') {
      return dbiPageLogMes.mobileGameDetailsStreamHourwatch;
    }
    if (tab === 'peackccv') {
      return dbiPageLogMes.mobileGameDetailsStreamPeakCCV;
    }
    if (tab === 'avgccv') {
      return dbiPageLogMes.mobileGameDetailsStreamAvgCCV;
    }
    if (tab === 'airtime') {
      return dbiPageLogMes.mobileGameDetailsStreamAirtime;
    }
  }
  if (entityType === 'pc') {
    if (tab === 'hourswatched') {
      return dbiPageLogMes.pcGameDetailsStreamHourwatch;
    }
    if (tab === 'peackccv') {
      return dbiPageLogMes.pcGameDetailsStreamPeakCCV;
    }
    if (tab === 'avgccv') {
      return dbiPageLogMes.pcGameDetailsStreamAvgCCV;
    }
    if (tab === 'airtime') {
      return dbiPageLogMes.pcGameDetailsStreamAirtime;
    }
  }
  if (entityType === 'console') {
    if (tab === 'hourswatched') {
      return dbiPageLogMes.consoleGameDetailsStreamHourwatch;
    }
    if (tab === 'peackccv') {
      return dbiPageLogMes.consoleGameDetailsStreamPeakCCV;
    }
    if (tab === 'avgccv') {
      return dbiPageLogMes.consoleGameDetailsStreamAvgCCV;
    }
    if (tab === 'airtime') {
      return dbiPageLogMes.consoleGameDetailsStreamAirtime;
    }
  }
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    if (tab === 'hourswatched') {
      return dbiPageLogMes.pcConsoleGameDetailsStreamHourwatch;
    }
    if (tab === 'peackccv') {
      return dbiPageLogMes.pcConsoleGameDetailsStreamPeakCCV;
    }
    if (tab === 'avgccv') {
      return dbiPageLogMes.pcConsoleGameDetailsStreamAvgCCV;
    }
    if (tab === 'airtime') {
      return dbiPageLogMes.pcConsoleGameDetailsStreamAirtime;
    }
  }
  return null;
}